module.exports = __webpack_public_path__ + "media/images/abstract-bg-4-1e3e0a59328411bc5f20bdb9a14a505c.svg";